import { Outlet } from 'react-router-dom';

export const BorrowerProfile = () => {
	return <Outlet></Outlet>;
};
